import axios from "axios";
import { drawId, Token } from "../urlParams";
import { REACT_APP_USER_API_URL } from "../../envVariables";

interface BuyTicketTpes {
  data: {
    gridSize: string;
    userTickets: userTickets[];
  };
}

type userTickets = {
  totalPrizeWin: number;
  status: number;
  ticketType: number;
  id: number;
  // gridItems:
};

export const buyTicket = async (
  selectedNumber: number,
  WalletId: number | undefined,
  totalAmount: number
) => {
  try {
    const response = await axios.post(
      `${REACT_APP_USER_API_URL}lottery/buy-ticket`,
      {
        numberOfTickets: selectedNumber,
        walletId: WalletId,
        drawId: drawId,
        totalAmount: totalAmount,
      },

      {
        headers: {
          Authorization: `AccessToken=${Token}`,
        },
      }
    );

    return response.data;
  } catch (error: any) {
    console.log(error.response.data.errors[0].name);
    throw error;
  }
};
